import {
  getDeliveryCadences as getDeliveryCadencesRequest,
  removeDeliveryCadence as removeDeliveryCadenceRequest,
  setDeliveryCadence as setDeliveryCadenceRequest
} from '@/api/generated/delivery-cadence/delivery-cadence'
import {
  createOrganization as createOrganizationRequest,
  getOrganization as getOrganizationRequest,
  getOrganizations,
  searchOrganizations as searchOrganizationsRequest,
  updateOrganization as updateOrganizationRequest
} from '@/api/generated/organization/organization'
import {
  OrganizationDTO,
  SearchResultOfOrganizationDTO,
  CreateOrganizationRequest,
  DeliveryCadenceDTO,
  SearchRequest,
  SetDeliveryCadenceRequest,
  UpdateOrganizationRequest
} from '@/api/generated/model'
import { SearchResult } from '@/api/search-result'

export const createOrganization = async function (
  request: CreateOrganizationRequest
): Promise<OrganizationDTO> {
  const response = await createOrganizationRequest(request)
  return response.data
}

export const searchOrganizations = async (
  request?: SearchRequest
): Promise<SearchResultOfOrganizationDTO> => {
  // A missing request goes out with no body, as before.
  const response = await searchOrganizationsRequest(request!)
  return response.data
}

// Super Admin only.
export const getAllOrganizations = async (): Promise<OrganizationDTO[]> => {
  const response = await getOrganizations()
  return response.data
}

export const getOrganization = async function (
  organizationID: string
): Promise<OrganizationDTO> {
  const response = await getOrganizationRequest(organizationID)
  return response.data
}

export const updateOrganization = async function (
  request: UpdateOrganizationRequest
): Promise<OrganizationDTO> {
  const response = await updateOrganizationRequest(request)
  return response.data
}

// DEV-1308: the late-file check of a distributor. Super Admin only.
export const getDeliveryCadences = async function (
  organizationID: string
): Promise<DeliveryCadenceDTO[]> {
  const response = await getDeliveryCadencesRequest(organizationID)
  return response.data
}

export const setDeliveryCadence = async function (
  organizationID: string,
  arrivalType: string,
  request: SetDeliveryCadenceRequest
): Promise<DeliveryCadenceDTO> {
  const response = await setDeliveryCadenceRequest(
    organizationID,
    arrivalType,
    request
  )
  return response.data
}

export const removeDeliveryCadence = async function (
  organizationID: string,
  arrivalType: string
): Promise<void> {
  await removeDeliveryCadenceRequest(organizationID, arrivalType)
}
